import {
    CardHeader,
    Divider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../routes';
import { DigestReportLead } from '../../sic-lib/api/activityReport/types/ActivityReport';

interface Props {
    newContacts: DigestReportLead[] | undefined;
}

export default function NewContactsReport({ newContacts }: Props) {
    const { classes } = useStyles();
    const history = useHistory();

    const newContactsData = React.useMemo(() => {
        return newContacts || [];
    }, [newContacts]);

    const handleNewContactClick = (leadId: number) => {
        history.push(contactRoutes.setDetails(leadId));
    };

    if (newContactsData.length === 0) {
        return <></>;
    }
    return (
        <Paper className={classes.root}>
            <CardHeader title="New Contacts Report" />
            <Divider />
            <TableContainer component={Paper}>
                <Table size="small" aria-label="new-contacts-report">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="center">Email</TableCell>
                            <TableCell align="center">Phone</TableCell>
                            <TableCell align="center">Lead Status</TableCell>
                            <TableCell align="center">TMS Code</TableCell>
                            <TableCell align="center">Description</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {newContactsData.map(item => {
                            return (
                                <TableRow
                                    hover
                                    key={item.leadId}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => handleNewContactClick(item.leadId)}
                                >
                                    <TableCell component="th" scope="row">
                                        {item.name}
                                    </TableCell>
                                    <TableCell align="center">{item.email}</TableCell>
                                    <TableCell align="center">{item.phone}</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">TMS_CODE</TableCell>
                                    <TableCell align="center">{item.description}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(2),
    },
}));
